import { FC } from 'react';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import TemplatesTable from '../TemplatesTable';
import { SFilterSelect, SFiltersRow, SFiltersWrapper } from '../styles';
import { TemplateFilters } from '../useTemplateFilters';
import TemplateSearchInput from './TemplateSearchInput';
import { Space } from 'antd';

const countryOptions = [
    { label: 'Ireland', value: DeclarationCountry.IRELAND },
    { label: 'UK', value: DeclarationCountry.UK },
    { label: 'EU', value: DeclarationCountry.EU },
];

interface Props {
    filters: TemplateFilters;
    archived: boolean;
}

const DeclarationTemplatesTab: FC<Props> = ({ filters, archived }) => (
    <>
        <SFiltersWrapper>
            <SFiltersRow>
                <TemplateSearchInput onSearch={filters.changeSearch} />
                <Space size={6}>
                    <SFilterSelect
                        options={countryOptions}
                        value={filters.country}
                        onChange={(value) => filters.changeCountry(value as DeclarationCountry)}
                    />
                    <SFilterSelect
                        options={filters.internalTypeOptions}
                        value={filters.internalType}
                        onChange={filters.changeInternalType}
                    />
                    <SFilterSelect
                        options={filters.formTypeOptions}
                        value={filters.formType?.toUpperCase()}
                        onChange={filters.changeFormType}
                    />
                </Space>
            </SFiltersRow>
        </SFiltersWrapper>

        <TemplatesTable
            country={filters.country}
            internalType={filters.internalType}
            formType={filters.formType}
            atArchivedPath={archived}
            search={filters.search}
        />
    </>
);

export default DeclarationTemplatesTab;
